import React from 'react';
import FormContainer from '../../forms/FormContainer/FormContainer';

export default function Success() {

    return (
        <FormContainer>
            <div>
                <h2>We've got it!</h2>
                <p>Thank you, your CV will now be reviewed by our recruitment team and we will contact you shortly.</p>
                <a href="/jobs/" className="meatex-button">View jobs board</a>
            </div>
        </FormContainer>
    )
}